<template>
  <PSDepartStat />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
